import * as Sentry from "@sentry/react";

const isDev = process.env.NODE_ENV === "development";
const log = (...messages: any[]) => {
  if (isDev) {
    console.log(...messages);
  }
};

export const captureError = (error: any, errorObject?: any) => {
  console.error(error, errorObject);
  Sentry.withScope(function (scope) {
    scope.setLevel("error");

    Sentry.captureException({
      error,
      errorObject,
    });
  });
};

export default log;
